import React from "react";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import redefining_project1 from "../assests/Images/Redefining_Project1.jpg";
import Redefining_Project2 from "../assests/Images/Redefining_Project2.jpg";
import { Link } from "react-router-dom";
import { LuNewspaper } from "react-icons/lu";
import orsac from "../assests/Images/ORSAC_Project.jpg";
import revolution1 from "../assests/Images/RevolutionizingSales_Project1.jpg";
import revolution2 from "../assests/Images/RevolutionizingSales_Project2.jpg";
import WaveEffect from "../Components/WaveEffect";

const RedefiningProductivityProject = () => {
  return (
    <div>
      <Navbar />
      <div
        className="bg-cover bg-center h-[50vh] lg:h-[75vh] md:h-[500px] sm:h-[400px] sm:rounded-tl-[390px] xl:rounded-tl-[530px]"
        style={{ backgroundImage: `url(${Redefining_Project2})` }}
      >
        <div className="h-full bg-black bg-opacity-80 w-full flex flex-col justify-center items-center sm:rounded-tl-[390px] xl:rounded-tl-[530px]">
          <WaveEffect
            text="Redefining Productivity Incentives"
            textClassName="text-white text-xl lg:text-5xl xl:text-5xl 2xl:text-3xl sm:text-3xl 2xl:text-5xl font-bold"
          />
          <div className="h-1 lg:h-2 xl:h-2 2xl:h-2 mt-4 w-24 bg-white" />
        </div>
      </div>

      <div className="m-10 xl:m-28 lg:m-20 md:m-16 sm:m-10 flex flex-col xl:flex-row lg:flex-row md:flex-col sm:flex-col gap-20 h-full sm:mt-10 ">
        <div className="w-full">
          <img
            src={redefining_project1}
            alt=""
            className="lg:h-[35rem] w-full rounded-xl object-cover"
          />
        </div>

        <div className="flex justify-center">
          <div className="w-[35rem] h-fit shadow-lg p-10 md:w-[25rem]  sm:w-[20rem]  place-items-center ">
            <div className="flex flex-row gap-2 justify-start items-center border-b-2 border-gray-300">
              <LuNewspaper className="text-2xl text-primary" />
              <h1 className="text-2xl font-bold pb-4 text-center">
                Recent Case Studies
              </h1>
            </div>

            <div className="flex flex-row gap-3 border-b-2 border-gray-300 py-5">
              <img
                src={orsac}
                alt=""
                className=" h-14 w-full object-contain rounded-2xl"
              />
              <div className="w-full ">
                <h1 className="text-gray-500">April 3, 2025</h1>
                <Link to="/orsac-project" className="hover:text-primary">
                  <h1 className="font-semibold text-lg">GIS & Remote Sensing Applications</h1>
                </Link>
              </div>
            </div>

            <div className="flex flex-row gap-3 border-b-2 border-gray-300 py-5">
              <img
                src={revolution2}
                alt=""
                className=" h-16 w-full object-contain rounded-2xl"
              />
              <div className="w-full ">
                <h1 className="text-gray-500">September 9, 2020</h1>
                <Link to="/redefining-productivity-incentives" className="hover:text-primary">
                  <h1 className="font-semibold text-lg">
                    Redefining Productivity Incentives
                  </h1>
                </Link>
              </div>
            </div>

            <div className="flex flex-row gap-3 py-5">
              <img
                src={Redefining_Project2}
                alt=""
                className="h-14 w-full object-contain rounded-2xl"
              />
              <div className="w-full ">
                <h1 className="text-gray-500">September 9, 2020</h1>
                <Link to="/revolutionizing-sales-operations" className="hover:text-primary">
                  <h1 className="font-semibold text-lg">
                    Revolutionizing Sales Operations
                  </h1>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col justify-center items-center text-start gap-10 lg:px-28 p-10 text-lg mb-20">
        <p>
          <span className="font-semibold text-primary">The Challenge:</span>{" "}
          Wheels India, a powerhouse in the manufacturing sector, faced a
          critical roadblock. Their legacy incentive scheme, outdated and
          opaque, was stalling progress. It lacked the transparency and direct
          correlation with productivity that a modern manufacturing giant
          demands. The result? A disengaged workforce and a misaligned incentive
          structure that was costing the company both in morale and in output.
        </p>
        <p>
          <span className="font-semibold text-primary">
            The Strategic Pivot:
          </span>{" "}
          Recognizing the urgency, Wheels India engaged our team—the industry’s
          foremost experts in productivity optimization. We approached the
          challenge with the precision and insight that only a market leader can
          provide. Our deep dive into the existing system revealed what was
          holding Wheels India back: an incentive structure that no longer
          served its purpose.
        </p>
        <p>
          <span className="font-semibold text-primary">The Solution:</span> We
          didn’t just tweak the old system—we reinvented it. By categorizing
          employees based on their direct impact on production, we created a
          tiered incentive structure that rewarded real performance. Our
          integration with SAP ensured that every aspect of the scheme was
          transparent, easily manageable, and, most importantly, aligned with
          Wheels India’s high standards of excellence.
        </p>
        <p>
          <span className="font-semibold text-primary">The Outcome:</span> The
          results spoke volumes. The new incentive scheme was a game-changer,
          boosting performance thresholds by 23% and extending rewards across
          the entire workforce—from trainees to senior management. The seamless
          integration and clear metrics not only won over the unions but also
          energized the entire organization. Wheels India emerged stronger, with
          a workforce that was not just motivated but aligned with the company’s
          ambitious goals. This transformation reaffirmed our role as the go-to
          partner for businesses aiming to lead with innovation and efficiency.
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default RedefiningProductivityProject;
